import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../partials/header/header.component';
import { ControlButtonComponent } from '../partials/control-button/control-button.component';
import { FooterComponent } from '../partials/footer/footer.component';
import { MaterialModule } from '../material.module';
import { DesignComponent } from '../partials/design/design.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeModule } from '../@core/pipes/pipe-modules/safe.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DeleteImageLibraryDialogComponent } from '../partials/dialog/builder/delete-image/delete-image-library.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { DmdDirective } from '../@core/directives/drag-image-drop.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    ControlButtonComponent,
    FooterComponent,
    DesignComponent,
    DeleteImageLibraryDialogComponent,
    DmdDirective
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    SafeModule.forRoot(),
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    RouterModule
  ],
  exports: [
    // components
    HeaderComponent,
    ControlButtonComponent,
    FooterComponent,
    DesignComponent,
    DeleteImageLibraryDialogComponent,
    // Modules
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    RouterModule,
    // DerictiveComponent
    DmdDirective
  ],
})
export class SharedComponentsModule { }
